import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import {
  CSS_HEIGHT_ANIMATION,
  CSS_DESKTOP_HEIGHT,
  SEARCH_INPUT_HEIGHT,
  SEARCH_PREVIEW_SEE_ALL_HEIGHT,
} from '../../../../constants';
import type { GetMobileCssVariableParams } from '../../../../utils/getMobileCssVariable';
import { getSearchInputTopAttribute } from '../../../../utils/getMobileCssVariable';
import { MAX_SEARCH_HEIGHT } from '../../../SearchPreview/constants';
import { SEARCH_INPUT_BOX_HEIGHT } from '../../constants';

export const SearchPreviewRoot = styled('div')(({ theme }) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  left: 0,
  padding: theme.spacing(3, 0),
  position: 'absolute',
  top: SEARCH_INPUT_HEIGHT,
  transition: `top ${CSS_HEIGHT_ANIMATION}`,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    position: 'static',
    padding: 0,
    borderRadius: theme.spacing(0, 0, 3, 3),
  },
}));

interface SearchPreviewContentProps extends GetMobileCssVariableParams {
  innerHeight: number;
}
export const SearchPreviewContent = styled('div', {
  shouldForwardProp: shouldForwardProp(),
})<SearchPreviewContentProps>(({ innerHeight, isTopBannerVisible, showSearchOnScroll, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: `calc(${innerHeight}px - ${SEARCH_PREVIEW_SEE_ALL_HEIGHT}px - ${getSearchInputTopAttribute({ isTopBannerVisible, showSearchOnScroll })} - ${SEARCH_INPUT_HEIGHT}px)`,
  position: 'relative',
  width: '100%',
  overscrollBehaviorY: 'contain',
  overflowY: 'scroll',

  [theme.breakpoints.up('md')]: {
    height: `min(${MAX_SEARCH_HEIGHT - SEARCH_INPUT_BOX_HEIGHT}px, calc(${innerHeight}px - ${CSS_DESKTOP_HEIGHT}))`,
    overflowY: 'visible',
  },
}));
